export enum FramesSearchType {
  EXACT = 'EXACT',
  PREFIX = 'PREFIX',
}

export interface FramesRecord {
  accountNumber: string;
  accountDescription: string;
}

export interface GetFramesAccountsResponse {
  framesAccounts: FramesRecord[];
  nextToken: string;
}
